const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        metrics: {
          filterDate: "Filtrar por dia",
          sales: {
            title: "Vendas",
            subtitle: "{{count}} purchase(s) enviado(s) ao pixel",
          },
          clicks: {
            title: "Cliques no link",
            subtitle: "Acessos ao contador no dia selecionado",
          },
          conversations: {
            title: "Conversas iniciadas",
            subtitle: "Contatos identificados no Whaticket no dia",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
          whatsappIdCopied: "WhatsApp ID copiado! Cole no MacroDroid (campo whatsappId).",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          hybridConnected: {
            content:
              "Web ativo: recebe mensagens e envia mídia. Vincule o USB para envio de texto pelo celular.",
          },
          webOnlyConnected: {
            content:
              "Modo somente Web: recebe e envia tudo pela sessão Web (ideal para iPhone).",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
          waitingAgent: {
            title: "Aguardando agente Android",
            content:
              "Inicie o android-bridge-agent no PC e conecte o celular via USB.",
          },
          deviceConnected: {
            title: "Dispositivo Android conectado",
            content: "Sessão ativa via bridge USB.",
          },
          deviceOffline: {
            title: "Dispositivo offline",
            content:
              "O agente local perdeu conexão. Verifique USB, adb e se o agente está rodando.",
          },
        },
        table: {
          name: "Nome",
          whatsappId: "WhatsApp ID",
          whatsappIdHint:
            "Clique no ID para copiar. Use no JSON do MacroDroid: \"whatsappId\": NÚMERO",
          copyWhatsappId: "Copiar WhatsApp ID",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          connectionMode: "Modo",
          counterPhone: "Número contador",
          autoDisableCounter: "Desativação automática",
        },
        autoDisable: {
          active: "Ativa",
        },
        connectionMode: {
          hybrid: "Híbrido",
          web: "Somente Web",
          usb: "USB (depuração)",
        },
        bridge: {
          title: "Android Bridge (USB)",
          hybridTitle: "Modo híbrido (Web + USB)",
          usbTitle: "Modo USB — sem WhatsApp Web",
          agentOnline: "Agente local online",
          agentOffline: "Agente local offline",
          instructions:
            "Receba mensagens pelo WhatsApp Web (QR Code). Envie texto pelo USB quando o agente estiver online; mídia sempre pelo Web. Sem MacroDroid.",
          hybridInstructions:
            "1) Abra o QR Code e escaneie no celular. 2) No mesmo modal, selecione o aparelho USB que leu o QR e clique em Vincular aparelho.",
          usbInstructions:
            "Sem QR Code. 1) Inicie INICIAR-FRANCA.bat no PC com o celular via USB. 2) Crie a conexão aqui. 3) Clique em Vincular aparelho. 4) Informe o WhatsApp ID no painel do PC. Mensagens entram pelas notificações do celular.",
          pairSectionTitle: "Vincular celular USB",
          pairHint:
            "Escolha o aparelho conectado via USB que escaneou este QR Code nesta instância.",
          selectDevice: "Celular USB",
          noDevices: "Nenhum celular detectado no agente local.",
          agentRequired:
            "Inicie o agente Bridge no PC com o celular conectado via USB.",
          alreadyPaired: "Aparelho vinculado:",
          keepAwakeTitle: "Manter tela ligada",
          keepAwakeMinutes: "Min",
          keepAwakeSave: "Salvar",
          keepAwakeSaved: "Timer de tela salvo.",
          keepAwakeInvalid: "Informe minutos válidos (0 desliga).",
          keepAwakeActive: "Ação a cada {{minutes}} min no aparelho USB.",
          keepAwakeOff: "Desligado (0 = sem ação).",
          escrcpyHint:
            "Espelhar tela: scrcpy -s SERIAL_DO_APARELHO (ou Escrcpy no PC).",
          pairDevice: "Vincular aparelho",
          paired: "Aparelho vinculado com sucesso!",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida",
          counterPhone: "Número do contador",
          autoDisableCounter: "Desativação automática",
          connectionMode: "Modo de conexão",
          connectionModeHybrid: "Híbrido (Web recebe + USB envia texto)",
          connectionModeWeb: "Somente Web (iPhone / sem USB)",
          connectionModeHybridHint:
            "Recebe mensagens pela Web e envia texto pelo celular Android via USB.",
          connectionModeWebHint:
            "Recebe e envia tudo pela sessão Web. Use para iPhone ou quando USB não funciona.",
          connectionModeUsb: "Somente USB (depuração Android)",
          connectionModeUsbHint:
            "Não use QR Code nem WhatsApp Web. Conecte o celular via USB, vincule o aparelho e use o agente Franca Bridge no PC.",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
        scanDone: "QR Code lido! Agora vincule o celular USB.",
        webActive: "Sessão Web ativa. Vincule o aparelho USB abaixo.",
        waiting: "Aguardando QR Code...",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          selectMedia: "Selecionar áudio ou vídeo pronto",
          selectAudio: "Selecionar áudio pronto",
          selectedAudio: "Áudio selecionado",
          audio: "Áudio",
          video: "Vídeo",
          messageOptionalWithAudio: "Opcional quando houver mídia anexada",
          messageOrAudioRequired: "Informe um texto ou selecione um áudio/vídeo",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        buttons: {
          accept: "Aceitar",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Tickets",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          pixel: "Pixel",
          counterNumbers: "Números",
          leadMessages: "Registro de Mensagens",
          queues: "Filas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
          proxy: "Proxy",
        },
        appBar: {
          autoAttend: "Atendimento automático com IA",
          translation: "Tradução em tempo real (desligar para não gastar API)",
          translationNeedsKey:
            "Configure a chave Google Translation em Configurações para activar",
          translationEnabled: "Tradução automática",
          agentLanguage: "Idioma principal (painel)",
          outputLanguage: "Idioma de saída (mensagens enviadas)",
          translationPrivacyNote:
            "Google Cloud Translation API. Active a API no Google Cloud Console.",
          translationApiKey: "Chave API Google Translation",
          translationApiKeyHelp:
            "Opcional se já tiver chave Gemini nas configurações de IA. Guarda sem validar Cloud Translation.",
          translationSaveApiKey: "Guardar chave",
          translationKeySaved: "Chave guardada com sucesso",
          translationKeyConfigured: "Chave Cloud Translation configurada",
          translationUsesGemini: "A usar chave Gemini das configurações de IA",
          translationKeyMissing: "Sem chave Cloud — usa Gemini da IA se existir",
          translationApiKeyEmpty: "Cole a chave antes de guardar",
          translationApiKeyReplace: "Cole nova chave para substituir",
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          audio: "Mídia",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          aiAssistant: {
            title: "Assistente IA",
            privacyNote:
              "As conversas são enviadas ao provedor de IA configurado (Gemini ou Anthropic). Configure as chaves abaixo.",
            provider: "Provedor ativo",
            geminiSection: "Google Gemini",
            anthropicSection: "Anthropic (Claude Sonnet)",
            model: "Modelo Gemini",
            anthropicModel: "Modelo Claude",
            apiKey: "Chave API Gemini",
            anthropicApiKey: "Chave API Anthropic",
            saveApiKey: "Salvar chave Gemini",
            saveAnthropicApiKey: "Salvar chave Anthropic",
            postSalePromptTitle: "Prompt pós-venda (botão IA na conversa)",
            prompt: "Prompt pós-venda",
            promptHelp:
              "Placeholders: {nome}, {telefone}, {valor_venda}, {utm_campaign}",
            savePrompt: "Salvar prompt pós-venda",
            atendimentoPromptTitle: "Prompt atendimento (auto-aceitar conversas)",
            atendimentoPromptHelp:
              "Usado quando o atendimento automático está ligado no topo. Separado do pós-venda.",
            atendimentoPrompt: "Prompt atendimento",
            saveAtendimentoPrompt: "Salvar prompt atendimento",
            autoAttendNewContactsOnly: "IA automática só para contatos novos",
            autoAttendNewContactsOnlyHelp:
              "Quando activo, o atendimento automático com IA só inicia para contactos que nunca receberam resposta humana. Quem já foi atendido por um agente fica à espera de atendimento humano.",
            autoAttendNewContactsOnlyOptions: {
              enabled: "Activado",
              disabled: "Desactivado",
            },
            maxReplies: "Máx. respostas por hora (por ticket)",
            historyMessages: "Mensagens de histórico no contexto (recomendado: 40+)",
            replyDelayMin: "Atraso mínimo (segundos)",
            replyDelayMax: "Atraso máximo (segundos)",
            replyDelayHelp:
              "A IA espera um tempo aleatório entre mínimo e máximo antes de responder. Se máximo = 0 ou igual ao mínimo, usa o mínimo fixo.",
          },
          translation: {
            title: "Tradução em tempo real",
            privacyNote:
              "Usa Google Cloud Translation API. Active a API no Google Cloud Console (separada do Gemini).",
            enabled: "Tradução activa",
            agentLanguage: "Idioma do agente (o que lê e escreve no painel)",
            apiKey: "Chave API Google Translation",
            apiKeyHelp:
              "Pode usar a mesma conta Google do Gemini, mas precisa activar Cloud Translation API.",
            saveApiKey: "Salvar chave de tradução",
            options: {
              enabled: "Activada",
              disabled: "Desactivada",
            },
          },
        },
      },
      messagesList: {
        aiBadge: "IA",
        translationLabel: "Tradução",
        sentTranslationLabel: "Enviado",
        translateButton: "Traduzir",
        translating: "Traduzindo...",
        header: {
          assignedTo: "Atribuído à:",
          aiActive: "IA ativa",
          aiModeSdr: "SDR",
          aiModePostSale: "Pós-venda",
          aiDisable: "Desligar IA",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            pixel: "Pixel",
            ai: "IA",
            aiOn: "IA ligada",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        quickAnswerAudio: "Áudio pronto",
        quickAnswerVideo: "Vídeo pronto",
        translationPreview: "Será enviado em {{language}}: {{text}}",
        translationAgentPreview: "Tradução para {{language}}: {{text}}",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        customerLanguage: "Idioma do cliente",
        customerLanguageAuto: "Detectar automaticamente",
        pixelCreative: "Criativo (Pixel)",
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_TRANSLATION_FAILED:
          "Não foi possível traduzir a mensagem. Verifique a chave e a Cloud Translation API no Google Cloud.",
        ERR_TRANSLATION_API_BLOCKED:
          "A Cloud Translation API está bloqueada. Active em console.cloud.google.com/apis/library/translate.googleapis.com e verifique restrições da chave.",
        ERR_TRANSLATION_INVALID_KEY:
          "Chave Google Translation inválida. Gere uma nova chave no Google Cloud Console.",
        ERR_TRANSLATION_KEY_TEST_FAILED:
          "Não foi possível validar a chave Google Translation. Tente novamente.",
        ERR_TRANSLATION_API_KEY_EMPTY: "Informe a chave Google Translation.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_PIXEL_INVALID_VALUE: "Informe um valor de venda válido.",
        ERR_PIXEL_LEAD_NOT_FOUND: "Lead do pixel não encontrado para este contato.",
        ERR_PIXEL_ALREADY_CONVERTED: "Esta conversão já foi enviada ao pixel.",
        ERR_PIXEL_PHONE_NOT_FOUND: "Telefone do contato não encontrado.",
        ERR_PIXEL_SEND_FAILED: "Erro ao enviar conversão para o pixel.",
        ERR_PIXEL_MESSAGE_REQUIRED: "Informe a mensagem para buscar o lead.",
        ERR_PIXEL_DATE_REQUIRED: "Informe a data do clique.",
        ERR_PIXEL_LEAD_ID_REQUIRED: "Lead inválido para envio.",
        ERR_PIXEL_LOOKUP_FAILED: "Erro ao buscar lead no pixel.",
        ERR_COUNTER_NUMBERS_LIST: "Erro ao listar números do contador.",
        ERR_COUNTER_NUMBER_ADD: "Erro ao adicionar número.",
        ERR_COUNTER_NUMBER_TOGGLE: "Erro ao alterar status do número.",
        ERR_COUNTER_NUMBER_UPDATE: "Erro ao atualizar número.",
        ERR_COUNTER_NUMBER_DELETE: "Erro ao remover número.",
        ERR_LEAD_MESSAGES_LIST: "Erro ao listar mensagens recentes.",
      },
      leadMessages: {
        title: "Registro de Mensagens",
        section: {
          title: "Últimas Mensagens Recebidas",
          subtitle:
            "Leads recentes — mensagem, número WPP destino, campanha e estado",
        },
        stats: {
          total: "Total de leads",
          today: "Leads hoje",
          converted: "Convertidos",
        },
        table: {
          date: "Data/Hora",
          message: "Mensagem",
          destination: "Nº WPP Destino",
          campaign: "Campanha",
          status: "Estado",
        },
        status: {
          pending: "Pendente",
          converted: "Vendido · €{{value}}",
        },
        empty: "Nenhuma mensagem recebida ainda.",
      },
      proxy: {
        title: "Proxy WhatsApp",
        formatHint:
          "Cole no formato host:porta:usuario:senha — tipo padrão HTTP (opcional: socks5 ou socks4 no final)",
        status: {
          enabled: "Proxy ativo",
          disabled: "Proxy desativado",
        },
        source: {
          settings: "Origem: painel",
          env: "Origem: .env",
          none: "Nenhum proxy configurado",
        },
        fields: {
          enabled: "Usar proxy no WhatsApp",
          rawLine: "Proxy completo",
          parsedTitle: "Campos reconhecidos automaticamente",
          host: "Host",
          port: "Porta",
          username: "Usuário",
          password: "Senha",
          passwordKeep: "Deixe em branco para manter a senha atual",
          type: "Tipo",
        },
        buttons: {
          save: "Salvar proxy",
          check: "Testar proxy",
          reload: "Recarregar",
        },
        check: {
          ok: "Proxy funcionando",
          fail: "Falha no teste do proxy",
          latency: "Latência: {{ms}} ms",
          ip: "IP externo: {{ip}}",
        },
        toasts: {
          saved: "Proxy salvo com sucesso!",
          checkOk: "Proxy testado com sucesso!",
          checkFail: "Proxy não respondeu",
        },
        note:
          "Após alterar o proxy, desconecte e reconecte a sessão WhatsApp em Conexões para aplicar a mudança.",
      },
      counterNumbers: {
        title: "Números do Contador",
        stats: {
          daily: "Cliques no dia",
          total: "Cliques totais",
          active: "Canais ativos",
        },
        form: {
          addTitle: "Adicionar novo canal",
          name: "Nome / Identificação",
          namePlaceholder: "ex: WPP Principal",
          phone: "Telefone",
          message: "Mensagem padrão (opcional)",
          add: "Adicionar",
          save: "Salvar",
          cancel: "Cancelar",
          phoneRequired: "Informe o telefone.",
        },
        table: {
          active: "Ativo",
          name: "Canal",
          daily: "Cliques (dia)",
          total: "Cliques (total)",
          rotation: "Rotação",
          actions: "Ações",
        },
        rotation: {
          next: "Próximo",
          last: "Último",
          queued: "Em fila",
          inactive: "Inativo",
        },
        edit: {
          title: "Editar canal",
        },
        confirmDelete: {
          title: "Remover número",
          message: "Tem certeza? O número será removido do contador de cliques.",
        },
        toasts: {
          added: "Número adicionado com sucesso!",
          updated: "Número atualizado!",
          deleted: "Número removido!",
        },
      },
      pixel: {
        title: "Pixel",
        creative: "Criativo",
        adLabel: "Anúncio",
        adId: "Ad ID",
        adNotFound: "Anúncio não identificado",
        campaignLabel: "Campanha",
        campaignNotFound: "Campanha não identificada",
        search: "Buscar por mensagem, telefone ou criativo",
        loadMore: "Carregar mais",
        stats: {
          total: "Verificados",
          complete: "Completos",
          incomplete: "Incompletos",
          converted: "Convertidos",
        },
        table: {
          contact: "Contato",
          message: "Mensagem",
          creative: "Criativo",
          phone: "Telefone",
          status: "Status Pixel",
          checkedAt: "Verificado em",
        },
        status: {
          complete: "Completo",
          incomplete: "Incompleto",
          notFound: "Não encontrado",
          convertedShort: "Convertido",
          converted: "Convertido · €{{value}}",
          purchasesSummary: "{{count}} purchase(s) · Total €{{value}}",
        },
        modal: {
          title: "Enviar conversão ao Pixel",
          phone: "Telefone (automático)",
          value: "Valor da venda (€)",
          send: "Enviar ao Pixel",
          sendUpsell: "Enviar upsell",
          cancel: "Cancelar",
          refresh: "Verificar novamente",
          message: "Mensagem rastreada",
          lookupDate: "Data do clique",
          leadDate: "Data do clique",
          lastPurchase: "Último envio",
          invalidValue: "Informe um valor válido.",
          success: "Conversão enviada ao pixel com sucesso!",
          upsellSuccess: "Upsell enviado ao pixel com sucesso!",
          refreshed: "Dados do pixel atualizados.",
        },
        manual: {
          title: "Busca manual",
          date: "Data do clique",
          message: "Mensagem exata",
          messagePlaceholder: "Cole a mensagem que o cliente enviou ao WhatsApp",
          search: "Buscar lead",
          phone: "Telefone do comprador",
          notFound: "Nenhum lead encontrado para esta mensagem e data.",
          clear: "Limpar",
          messageRequired: "Informe a mensagem para buscar.",
          dateRequired: "Informe a data do clique.",
          phoneRequired: "Informe o telefone do comprador.",
        },
      },
    },
  },
};

export { messages };
